import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Holds the room of a text's longest version (NEWS-26): `longest` is laid
 * out invisible in the same grid cell as the content, in the content's text
 * box (`className`), so the content can be a skeleton, a short text or a long
 * one without moving what's around it; only the whitespace below a shorter
 * text changes. The reserve is generated content (`::before`), so it is not
 * in the page's text nor in the accessibility tree.
 */
export function TextReserve({
  longest,
  className,
  fromMd = false,
  children,
}: {
  longest: string;
  /** The text box of the content (font, size, line height, max width). */
  className: string;
  /** Reserve only from 768px up; below, the content takes its own room. */
  fromMd?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="grid">
      <p
        data-testid="text-reserve"
        data-reserve={longest}
        aria-hidden="true"
        className={cn(
          className,
          'invisible [grid-area:1/1] before:content-[attr(data-reserve)]',
          fromMd && 'max-md:hidden'
        )}
      />
      <div className="min-w-0 [grid-area:1/1]">{children}</div>
    </div>
  );
}
